/** Install the Matrix SDK send-queue API when the chat loads on older browsers. */
export function installPromiseWithResolvers(): void {
  if (typeof Promise.withResolvers === 'function') {
    return
  }

  Object.defineProperty(Promise, 'withResolvers', {
    configurable: true,
    writable: true,
    value: function withResolvers<T>(this: PromiseConstructor): PromiseWithResolvers<T> {
      let resolve!: (value: T | PromiseLike<T>) => void
      let reject!: (reason?: unknown) => void
      const promise = new this<T>((resolvePromise, rejectPromise) => {
        resolve = resolvePromise
        reject = rejectPromise
      })
      return { promise, resolve, reject }
    },
  })
}

installPromiseWithResolvers()
